module.exports = __webpack_public_path__ + "img/indexBg1.5a9664b0.png";